/** This interface should be used when fixed/absolute position elements are placed dynamically */
import { css } from 'styled-components';

export interface IPosition {
  anchor: 'top-left' | 'top-right' | 'bottom-left' | 'bottom-right';
  x: number | string;
  y: number | string;
}

export const positionStyles = css<{ position: IPosition }>`
  ${(props) => {
    switch (props.position.anchor) {
      case 'bottom-left':
        return `
          left: ${typeof props.position.x === 'number' ? props.position.x + 'px' : props.position.x};
          bottom: ${typeof props.position.y === 'number' ? props.position.y + 'px' : props.position.y};
        `;
      case 'bottom-right':
        return `
          right: ${typeof props.position.x === 'number' ? props.position.x + 'px' : props.position.x};
          bottom: ${typeof props.position.y === 'number' ? props.position.y + 'px' : props.position.y};
        `;
      case 'top-left':
        return `
          left: ${typeof props.position.x === 'number' ? props.position.x + 'px' : props.position.x};
          top: ${typeof props.position.y === 'number' ? props.position.y + 'px' : props.position.y};
        `;
      case 'top-right':
        return `
          right: ${typeof props.position.x === 'number' ? props.position.x + 'px' : props.position.x};
          top: ${typeof props.position.y === 'number' ? props.position.y + 'px' : props.position.y};
        `;
    }
  }};
`;
